import { render, staticRenderFns } from "./pubDelicacy.vue?vue&type=template&id=72d62582&scoped=true&"
import script from "./pubDelicacy.vue?vue&type=script&lang=js&"
export * from "./pubDelicacy.vue?vue&type=script&lang=js&"
import style0 from "./pubDelicacy.vue?vue&type=style&index=0&id=72d62582&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d62582",
  null
  
)

export default component.exports